import React, { Component } from "react";
import "../../../public/styles/HomeInteriors/LocateUs/MobileNav.scss";
import { espotAPI, imagePrefix } from "../../../public/constants/constants";
import apiManager from "../../utils/apiManager";
import FormBody from "./OrphanPage/FormBody";

export default class MobileFixedNavbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      espotName: "GI_Interiors_Header",
      menu: [],
      source: this.props.pageSource || "",
      showModal: false,
    };
  }

  scrollTOForm = () => {
    if (this.state.source == "GI_Interiors_Orphan" || this.props.showModal == true || this.props.showModal == undefined) {
      this.setState({
        showModal: true,
      });
    } else {
      document.getElementById("HIConsultForm").scrollIntoView({
        behavior: "smooth",
      });
    }
  };

  closeModal = () => {
    this.setState({
      showModal: false,
    });
  };

  getHeaderData() {
    apiManager
      .get(espotAPI + this.state.espotName)
      .then(response => {
        const { data } = response || {};
        this.setState({
          //   logoimg: data && data.data.logoimg,
          menu: data && data.data.menu,
        });
      })
      .catch(error => {
        this.setState({
          error,
          isLoading: false,
        });
      });
  }

  componentDidMount() {
    this.getHeaderData();
  }

  render() {
    return (
      <div className="nav-fixed-container">
        <div className="nav-fixed-wrapper">
          <div className="button-container">
            <button   onClick={this.scrollTOForm}>BOOK A CONSULTATION</button>
          </div>
          <div className="nav-container">
            <ul className="nav-list-main">
              {!!this.state.menu &&
                this.state.menu.map((item, key) => (
                  <li>
                    <a
                      href={item.link}
                      style={{
                        color:
                          window.location.pathname == item.link
                            ? "#e3254e"
                            : "#000",
                      }}
                    >
                      <img
                        src={
                          window.location.pathname == item.link
                            ? imagePrefix + item.icon2
                            : imagePrefix + item.icon
                        }
                      />
                      {item.page}
                    </a>
                  </li>
                ))}
            </ul>
          </div>
        </div>
        {this.state.showModal ? (
          <>
            <FormBody
              // class="modal-orphan-form"
              pageSource={this.props.pageSource2 || this.props.pageSource}
              source
              closeModal={this.closeModal.bind(this)}
            />
          </>
        ) : (
          <></>
        )}
      </div>
    );
  }
}
